export default "__VITE_ASSET__BdCINMiV__"